import {
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
  Typography,
} from '@material-ui/core';
import AddBoxIcon from '@material-ui/icons/AddBox';
import Delete from '@material-ui/icons/Delete';

import React from 'react';
import { ACTIONLIST } from './Report.reducer';
import { operationList } from './constant';
import { FilterValue } from './FilterValue';
export const FilterQuery = ({ state, dispatch, data }) => {
  const typeList = [
    ...state.entityAssociationSelectedList,
    ...state.entitySelectedList,
  ];

  return (
    <Grid container justifyContent="center" style={{ padding: 30 }}>
      <Grid item sm={10}></Grid>
      <Grid item sm={2}>
        {state.filters?.length == 0 && (
          <Tooltip title="Add Filter">
            <IconButton
              color="primary"
              aria-label="Add"
              disabled={typeList.length == 0}
              onClick={() => {
                dispatch({
                  type: ACTIONLIST.UPDATE_FILTER_LIST,
                  payload: {
                    label: '',
                    rule: '',
                    name: '',
                    value: '',
                    relation: '',
                  },
                });
              }}
            >
              <AddBoxIcon />
            </IconButton>
          </Tooltip>
        )}
      </Grid>
      {state.filters?.length == 0 && (
        <Grid item sm={12} style={{ textAlign: 'center' }}>
          <Typography>No Filter Added Yet</Typography>
        </Grid>
      )}
      <Grid item sm={12} style={{ marginTop: 10, marginLeft: 10 }}>
        {state.filters?.map((filter, index) => {
          return (
            <Grid container key={filter.name} spacing={2} alignItems="center">
              <Grid item sm={2} >
                <FormControl required fullWidth variant="outlined" style={{ display: index !=0 ? '' : 'none' }}>
                  <InputLabel id="outlined-label-entity-type">
                    And/Or
                  </InputLabel>
                  <Select
                    labelId="outlined-label-entity-type"
                    placeholder="And/Or"
                    name="operator"
                    // disabled={index != 0}
                    value={filter.relation}
                    onChange={(e) => {
                      const { value } = e.target;
                      dispatch({
                        type: ACTIONLIST.UPDATE_FILTER_JOIN,
                        payload: { value, index },
                      });
                    }}
                    label="And/Or"
                  >
                    <MenuItem value="and">And</MenuItem>
                    <MenuItem value="or">Or</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item sm={3}>
                <FormControl required fullWidth variant="outlined">
                  <InputLabel id="outlined-label-entity-type">Type</InputLabel>
                  <Select
                    labelId="outlined-label-entity-type"
                    placeholder="Data Type"
                    name="data_type"
                    value={filter.name}
                    onChange={(e) => {
                      const { value } = e.target;
                      const selectItem = typeList.find(
                        (item) => item.name == value,
                      );
                      const exitingFilter = state.filters.filter(
                        (item) => item.name == value,
                      ).length;
                      if (!exitingFilter) {
                        dispatch({
                          type: ACTIONLIST.UPDATE_FILTER_LIST_VALUE,
                          payload: {
                            value: {
                              name: value,
                              rule: selectItem.rule.split('|'),
                              operator: '',
                              data_type: selectItem.data_type,
                              relation: filter.relation,
                            },
                            index,
                          },
                        });
                      } else {
                        dispatch({
                          type: ACTIONLIST.UPDATE_FILTER_LIST_VALUE,
                          payload: {
                            value: {
                              name: '',
                              rule: '',
                              operator: '',
                              relation: filter.relation,
                            },
                            index,
                          },
                        });
                      }
                    }}
                    label="Entity Type"
                  >
                    {typeList.map((val, index2) => {
                      if (!['policies_version', 'procedures'].includes(val)) {
                        return (
                          <MenuItem key={index2} value={val.name}>
                            {val.label}
                          </MenuItem>
                        );
                      }
                    })}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item sm={2} style={{ display: filter.name ? '' : 'none' }}>
                <FormControl required fullWidth variant="outlined">
                  <InputLabel id="outlined-label-entity-type">
                    Operator
                  </InputLabel>
                  <Select
                    labelId="outlined-label-entity-type"
                    placeholder="Operator"
                    name="operator"
                    value={filter.operator}
                    onChange={(e) => {
                      const { value } = e.target;
                      dispatch({
                        type: ACTIONLIST.UPDATE_FILTER_OPERATOR,
                        payload: { value, index },
                      });
                    }}
                    label="Operator"
                  >
                    {operationList
                      .filter((item) => filter.rule.includes(item.name))
                      .map((val, index2) => {
                        return (
                          <MenuItem key={index2} value={val.name}>
                            {val.label}
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
              </Grid>

              <Grid
                item
                sm={4}
                style={{ display: filter.operator ? '' : 'none' }}
              >
                <FilterValue
                  state={state}
                  dispatch={dispatch}
                  data={filter}
                  indexValue={index}
                />
              </Grid>
              <Grid item sm={1} style={{ display: filter.value ? '' : 'none' }}>
                {index + 1 == state.filters.length ? (
                  <>
                    <Tooltip title="Add Filter">
                      <IconButton
                        color="primary"
                        aria-label="Add"
                        disabled={
                          !filter.value ||
                          !filter.operator
                        }
                        onClick={() => {
                          dispatch({
                            type: ACTIONLIST.UPDATE_FILTER_LIST,
                            payload: {
                              label: '',
                              rule: '',
                              value: '',
                              relation: filter.relation,
                            },
                          });
                        }}
                      >
                        <AddBoxIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete Filter">
                      <IconButton
                        color="primary"
                        aria-label="Delete"
                        onClick={() => {
                          dispatch({
                            type: ACTIONLIST.DELETE_FILTER,
                            payload: filter.name,
                          });
                        }}
                      >
                        <Delete />
                      </IconButton>
                    </Tooltip>
                  </>
                ) : (
                  <Tooltip title="Delete Filter">
                    <IconButton
                      color="primary"
                      aria-label="Delete"
                      onClick={() => {
                        dispatch({
                          type: ACTIONLIST.DELETE_FILTER,
                          payload: filter.name,
                        });
                      }}
                    >
                      <Delete />
                    </IconButton>
                  </Tooltip>
                )}
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};
